import { render, staticRenderFns } from "./ResubmitChina.vue?vue&type=template&id=79921e98"
import script from "./ResubmitChina.vue?vue&type=script&lang=js"
export * from "./ResubmitChina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports